import { createContext, useContext, useState } from "react";
import {
  DEFAULT_CALCULATOR_TIMEZONE,
  readCalculatorValue,
} from "../utils/calculatorStorage";

const TimezoneContext = createContext();

/* hook so components can just `const { tz, setTZ } = useTZ()` */
export const useTZ = () => useContext(TimezoneContext);

export function TimezoneProvider({ children }) {
  const [tz, setTZ] = useState(() =>
    readCalculatorValue("timezone", DEFAULT_CALCULATOR_TIMEZONE)
  );          // global state
  return (
    <TimezoneContext.Provider value={{ tz, setTZ }}>
      {children}
    </TimezoneContext.Provider>
  );
}
